/* ss-cassetto.js — il carrello si apre di lato e si resta dov'eri */
(function () {
  var cas = document.getElementById('ss-cassetto');
  if (!cas) return;
  if (cas.parentNode !== document.body) document.body.appendChild(cas);

  var soglia = (parseFloat(cas.getAttribute('data-soglia')) || 0) * 100;
  var body   = cas.querySelector('[data-cas-body]');
  var sogBox = cas.querySelector('[data-cas-soglia]');
  var sogTxt = cas.querySelector('[data-cas-sogtxt]');
  var sogFil = cas.querySelector('[data-cas-fill]');
  var totEl  = cas.querySelector('[data-cas-tot]');
  var sugg   = cas.querySelector('[data-cas-sugg]');
  var rail   = cas.querySelector('[data-cas-rail]');
  var foot   = cas.querySelector('[data-cas-foot]');
  var ultimo = null;
  var svuota = cas.querySelector('[data-cas-svuota]');
  if (svuota) svuota.addEventListener('click', function () {
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { indice().then(function () { ultimo = null; disegna(c); contatore(c); }); });
  });

  function eur(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function icona(seg) {
    return "url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 " +
           "fill=%22%231E2224%22%3E" + seg + "%3C/svg%3E')";
  }
  var MENO = icona('%3Crect x=%224%22 y=%2211%22 width=%2216%22 height=%222.4%22 rx=%221.2%22/%3E');
  var PIU  = icona('%3Crect x=%224%22 y=%2211%22 width=%2216%22 height=%222.4%22 rx=%221.2%22/%3E%3Crect x=%2210.8%22 y=%224%22 width=%222.4%22 height=%2216%22 rx=%221.2%22/%3E');

  /* L'elenco dei prodotti consigliati arriva da Shopify senza i nostri metafield.
     Il passo e l'unita li prendo dall'indice che usa gia la ricerca. */
  var idx = null;
  function indice() {
    if (idx) return Promise.resolve(idx);
    var cache = null;
    try { cache = sessionStorage.getItem('ssIndice'); } catch (e) {}
    if (cache) { try { idx = mappa(JSON.parse(cache)); return Promise.resolve(idx); } catch (e) {} }
    return fetch('/collections/all?view=indice')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        try { sessionStorage.setItem('ssIndice', JSON.stringify(d)); } catch (e) {}
        idx = mappa(d); return idx;
      }).catch(function () { idx = {}; return idx; });
  }
  function mappa(d) {
    var m = {};
    (d || []).forEach(function (x) {
      var h = String(x.u || '').split('/products/')[1];
      if (h) m[h.split('?')[0]] = { modo: x.m || 'metro', passo: Number(x.s) || 0.5 };
    });
    return m;
  }
  function schedaDi(url) {
    var h = String(url || '').split('/products/')[1];
    return (idx && h) ? idx[h.split('?')[0]] : null;
  }

  function misura(it) {
    var t = it.properties && it.properties['Taglio'];
    if (t) return String(t).split(' (')[0];
    /* riga senza proprieta: se il prodotto va a metri lo dico lo stesso */
    var s = schedaDi(it.url);
    if (s && s.modo !== 'pezzo') {
      var m = it.quantity * s.passo;
      return (s.passo < 0.5 ? m.toFixed(2) : m.toFixed(1)).replace('.', ',') + ' m';
    }
    return it.quantity + (it.quantity === 1 ? ' pezzo' : ' pezzi');
  }

  function disegna(c) {
    if (!c.items.length) {
      body.innerHTML = '<p class="ss-cas__vuoto">Il carrello è vuoto.</p>';
      sogBox.hidden = true; sugg.hidden = true; foot.hidden = true;
      if (svuota) svuota.hidden = true;
      return;
    }
    foot.hidden = false;
    body.innerHTML = c.items.map(function (it) {
      return '<div class="ss-cas__r" data-key="' + it.key + '">' +
        '<a class="ss-cas__f" href="' + it.url + '">' +
          (it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_140x140_crop_center$1$2') + '" alt="">' : '') +
        '</a>' +
        '<div class="ss-cas__i">' +
          '<a class="ss-cas__n" href="' + it.url + '">' + it.product_title + '</a>' +
          (it.variant_title ? '<span class="ss-cas__v">' + it.variant_title + '</span>' : '') +
          '<div class="ss-cas__q">' +
            '<span class="ss-cas__step">' +
              '<span role="button" tabindex="0" data-giu style="background-image:' + MENO + '"></span>' +
              '<span class="ss-cas__m">' + misura(it).replace(' pezzi', ' pz').replace(' pezzo', ' pz') + '</span>' +
              '<span role="button" tabindex="0" data-su style="background-image:' + PIU + '"></span>' +
            '</span>' +
            '<span class="ss-cas__p2">' + eur(it.final_line_price) + '</span>' +
            '<span role="button" tabindex="0" class="ss-cas__via" data-via aria-label="Togli ' + it.product_title + '">&times;</span>' +
          '</div>' +
        '</div></div>';
    }).join('');

    body.querySelectorAll('[data-key]').forEach(function (r) {
      var key = r.getAttribute('data-key');
      var it = c.items.filter(function (x) { return x.key === key; })[0];
      r.querySelector('[data-su]').addEventListener('click', function () { cambia(key, it.quantity + 1, it); });
      r.querySelector('[data-giu]').addEventListener('click', function () { cambia(key, it.quantity - 1, it); });
      r.querySelector('[data-via]').addEventListener('click', function () { cambia(key, 0, it); });
    });

    totEl.textContent = eur(c.total_price);
    if (svuota) svuota.hidden = false;

    if (soglia > 0) {
      sogBox.hidden = false;
      var manca = soglia - c.total_price;
      sogTxt.innerHTML = manca <= 0
        ? 'Spedizione <b>gratuita</b>, ci pensiamo noi.'
        : 'Aggiungi <b>' + eur(manca) + '</b> e la spedizione diventa gratuita';
      sogFil.style.width = Math.min(100, c.total_price / soglia * 100) + '%';
    }

    var pid = c.items[0].product_id;
    if (pid && pid !== ultimo) { ultimo = pid; suggerisci(pid); }
  }

  function passoDi(it) {
    var t = it.properties && it.properties['Taglio'];
    if (t) {
      var m = parseFloat(String(t).split(' (')[0].replace(',', '.'));
      if (!isNaN(m)) return m / it.quantity;
    }
    var s = schedaDi(it.url);
    return (s && s.modo !== 'pezzo') ? s.passo : null;
  }

  function cambia(key, q, it) {
    if (q < 0) q = 0;
    var corpo = { id: key, quantity: q };
    var p = passoDi(it);
    if (p && q > 0) {
      var m = (q * p);
      corpo.properties = { 'Taglio': (p < 0.5 ? m.toFixed(2) : m.toFixed(1)).replace('.', ',') +
        ' m (' + q + ' \u00d7 ' + Math.round(p * 100) + ' cm)' };
    }
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(corpo)
    }).then(function (r) { return r.json(); }).then(function (c) { disegna(c); contatore(c); });
  }

  function suggerisci(pid) {
    indice();
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=6')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var p = (d && d.products || []).filter(function (x) {
          return x.variants && x.variants.some(function (v) { return v.available; });
        }).slice(0, 4);
        if (!p.length) { sugg.hidden = true; return; }
        sugg.hidden = false;
        rail.innerHTML = p.map(function (x) {
          var v = x.variants.filter(function (v) { return v.available; })[0];
          var img = x.featured_image ? x.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_240x240_crop_center$1$2') : '';
          return '<div class="ss-cas__s">' +
            '<a class="ss-cas__sf" href="' + x.url + '">' + (img ? '<img src="' + img + '" alt="">' : '') + '</a>' +
            '<div class="ss-cas__sb"><a class="ss-cas__sn" href="' + x.url + '">' + x.title + '</a>' +
            '<span role="button" tabindex="0" class="ss-cas__sadd" data-add="' + v.id + '" data-url="' + x.url + '">Aggiungi</span>' +
            '</div></div>';
        }).join('');
        rail.querySelectorAll('[data-add]').forEach(function (b) {
          b.addEventListener('click', function () {
            b.textContent = 'Un attimo…';
            var s = schedaDi(b.getAttribute('data-url'));
            var riga = { id: Number(b.getAttribute('data-add')), quantity: 1 };
            if (s && s.modo !== 'pezzo') {
              /* mezzo metro e il taglio minimo, come sulla scheda prodotto */
              riga.quantity = Math.max(1, Math.round(0.5 / s.passo));
              var m = riga.quantity * s.passo;
              riga.properties = { 'Taglio': (s.passo < 0.5 ? m.toFixed(2) : m.toFixed(1)).replace('.', ',') +
                ' m (' + riga.quantity + ' \u00d7 ' + Math.round(s.passo * 100) + ' cm)' };
            }
            fetch('/cart/add.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [riga] })
            }).then(function () { return fetch('/cart.js'); })
              .then(function (r) { return r.json(); })
              .then(function (c) { disegna(c); contatore(c); });
          });
        });
      }).catch(function () { sugg.hidden = true; });
  }

  function contatore(c) {
    var b = document.querySelector('[data-ss-count-cart]');
    if (b) b.textContent = c.item_count;
    document.dispatchEvent(new CustomEvent('ss:carrello', { detail: c }));
  }

  var ultimoFuoco = null;
  function apri() {
    ultimoFuoco = document.activeElement;
    cas.hidden = false;
    requestAnimationFrame(function () { cas.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('ss-cassetto-aperto');
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { disegna(c); contatore(c); });
    var x = cas.querySelector('.ss-cas__x'); if (x) x.focus();
  }
  function chiudi() {
    cas.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('ss-cassetto-aperto');
    setTimeout(function () { cas.hidden = true; }, 300);
    if (ultimoFuoco) ultimoFuoco.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('a[href*="/cart"], [data-cas-apri]') : null;
    if (t && !t.hasAttribute('data-cas-no')) {
      var h = t.getAttribute('href') || '';
      if (h.indexOf('/cart/') === -1) { e.preventDefault(); apri(); }
    }
    if (e.target.closest && e.target.closest('[data-cas-chiudi]')) chiudi();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !cas.hidden) chiudi(); });
  document.addEventListener('ss:aggiunto', apri);
  window.ssApriCassetto = apri;
})();
